<template>
  <div class="container">
    <div class="info">是否授权登录</div>
    <el-button type="primary" @click="handleAuthorize">授权登录</el-button>
  </div>
</template>

<script>
import { casLogin } from '@/api/user';
import Qs from 'qs'
export default {
  methods: {
    handleAuthorize() {
      let q = undefined
      const sps = window.location.href.substring(window.location.href.indexOf('?') + 1).split('#')
      for (let i = 0; i < sps.length; i++) {
        const s = sps[i]
        if (s.indexOf("service") >= 0) {
          q = Qs.parse(s)
          break
        }
      }
      if (q) {
        casLogin(q.service).then(res => {
          const service = q.service + '?ticket=' + res.data.ticket
          window.location.href = service
        }).catch(e => {
          console.log(e)
        })
      }
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.info {
  margin-bottom: 40px;
}
</style>